import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourAddressApi } from '../api/labourAddressApi'; 
import { RootState } from '..';

export interface LabourAddressState {
  labourAddressDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourAddressState = {
  labourAddressDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourAddressSlice = createSlice({
  name: 'labourAddress',
  initialState,
  reducers: {
    setAddressDetails: (state, action: PayloadAction<any>) => {
      state.labourAddressDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourAddressApi.endpoints.saveAddressDetail.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourAddressApi.endpoints.saveAddressDetail.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourAddressDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourAddressApi.endpoints.saveAddressDetail.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setAddressDetails, setLoading, setError, reset } = labourAddressSlice.actions;
export const getAddressDetails = (state: RootState) => state.labour.data;
export const getAddressDetailsTotalRecords = (state: RootState) => state.labour.totalRecords;

export default labourAddressSlice.reducer;